
import { useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';

interface MediaPermissionsProps {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

const MediaPermissions = ({ onSuccess, onError }: MediaPermissionsProps) => {
  const { toast } = useToast();
  
  useEffect(() => {
    const requestPermissions = async () => {
      try {
        await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
        
        toast({
          title: "Permissions granted",
          description: "Microphone and camera access has been granted."
        });
        
        if (onSuccess) onSuccess();
      } catch (err) {
        console.error("Media permission error:", err);
        
        toast({
          title: "Permission denied",
          description: "Please enable microphone and camera access to participate in this session.",
          variant: "destructive"
        });
        
        if (onError && err instanceof Error) onError(err);
      }
    };
    
    requestPermissions();
  }, [toast, onSuccess, onError]);
  
  return null; // This component doesn't render anything
};

export default MediaPermissions;
